<div class="modal-header"><h4 class="modal-title">Delete testing workflow of professional</h4></div>
<div class="modal-body">
    <ng-container *ngIf="!showRegistrationError">
        <p class="text-title">Warning</p>
        <p>
            Are you sure you want to delete this workflow? <br />
            Once you have done so, this workflow cannot be accessed. If any fees have been paid by the candidate, you
            may be responsible for refunding those fees. Are you sure you want to continue?
        </p>
        <p>Please select "Delete" button to continue</p>
    </ng-container>
    <ng-container *ngIf="showRegistrationError">
        <p class="text-title error-text">Error</p>
        <p class="error-text">
            We are unable to delete this workflow because the candidate has already registered with the testing
            provider. To request support to delete this workflow, please go to
            <a target="_blank" class="cm-link" [href]="supportLink">{{ supportLinkShort }}</a
            >.
        </p>
    </ng-container>
</div>
<div class="modal-footer">
    <ng-container *ngIf="!showRegistrationError">
        <button class="btn btn-default" (click)="close()">Back</button>
        <button class="btn btn-primary" (click)="onDeleteCertificate()">Delete</button>
    </ng-container>
    <ng-container *ngIf="showRegistrationError">
        <button class="btn btn-default" (click)="close()">Close</button>
    </ng-container>
</div>
